/**
 * Jewelry World [New] — hover/focus/tap flex morph + image scale
 * Timings match JewelryWorld.jsx (flex 1100ms, image 2200ms, reveal 1s + 0.12s stagger)
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'jewelry-world-new';
  var instances = new WeakMap();

  function JewelryWorldNew(root) {
    this.root = root;
    this.row = root.querySelector('[data-jw-row]');
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-jw-card]'));
    this.active = null;
    this.reducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.reducedMotion) root.classList.add('is-reduced-motion');

    this.bind();
    this.observeReveal();
  }

  JewelryWorldNew.prototype.bind = function () {
    var self = this;

    this.cards.forEach(function (card) {
      var index = parseInt(card.getAttribute('data-jw-card'), 10);

      card.addEventListener('mouseenter', function () {
        self.setActive(index);
      });

      card.addEventListener('focus', function () {
        self.setActive(index);
      });

      card.addEventListener('click', function () {
        self.setActive(index);
      });
    });

    if (this.row) {
      this.row.addEventListener('mouseleave', function () {
        self.setActive(null);
      });
    }
  };

  JewelryWorldNew.prototype.setActive = function (index) {
    this.active = index;

    if (this.row) {
      if (index === null) {
        this.row.classList.remove('is-hovering');
      } else {
        this.row.classList.add('is-hovering');
      }
    }

    this.cards.forEach(function (card, i) {
      if (index !== null && i === index) {
        card.classList.add('is-active');
      } else {
        card.classList.remove('is-active');
      }
    });
  };

  JewelryWorldNew.prototype.observeReveal = function () {
    var self = this;
    if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
      this.cards.forEach(function (card) {
        card.classList.add('is-inview');
      });
      return;
    }

    var rootMargin = window.matchMedia('(max-width: 767px)').matches
      ? '0px 0px 0px 0px'
      : '0px 0px -100px 0px';
    var threshold = window.matchMedia('(max-width: 767px)').matches ? 0.05 : 0.08;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-reveal-delay'), 10) || 0;
          window.setTimeout(function () {
            el.classList.add('is-inview');
          }, delay);
          observer.unobserve(el);
        });
      },
      { threshold: threshold, rootMargin: rootMargin }
    );

    this.cards.forEach(function (card) {
      observer.observe(card);
    });
  };

  function initAll() {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, new JewelryWorldNew(root));
    });
  }

  function onSectionLoad(event) {
    var section = event.target;
    if (!section) return;
    var root = section.querySelector
      ? section.querySelector('[data-section-type="' + SECTION_TYPE + '"]')
      : null;
    if (!root && section.getAttribute && section.getAttribute('data-section-type') === SECTION_TYPE) {
      root = section;
    }
    if (!root) return;
    instances.delete(root);
    instances.set(root, new JewelryWorldNew(root));
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (!section || !section.querySelector) return;
    var root = section.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
    if (root) instances.delete(root);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAll();
  }
})();
